import React from "react"
import TippyIcon from "./../../TippyIcon";
import { dashboardColors, theme } from "../../../../themes/Theme";

const EditQuickButton = ({ onClick, status, className, disabled, style, content, size }) => (
    <TippyIcon content={content ? content : `Edit`} placement="bottom">
        <i
            style={{ fontSize: `${size ? size : "16px"}`, color: dashboardColors[theme].primary, ...(style && { ...style }) }}
            className={`${status === 'completed' ? 'fa fa-eye' : 'fas fa-pen'} pen-color ${className}`}
            disabled={disabled ? disabled : false}
            onClick={onClick}>
        </i>
    </TippyIcon>
)

export default EditQuickButton;